export default ({ style }) => (
	<svg
		id="Layer_3"
		data-name="Layer 3"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 27 27"
	>
		<path
			style={style}
			className="cls-1"
			d="M13.5,10.38A3.915,3.915,0,1,0,17.414,14.3,3.919,3.919,0,0,0,13.5,10.38Zm0,7.329A3.415,3.415,0,1,1,16.914,14.3,3.418,3.418,0,0,1,13.5,17.709Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M13.5,12.41A1.885,1.885,0,1,0,15.385,14.3,1.886,1.886,0,0,0,13.5,12.41Zm0,3.27A1.385,1.385,0,1,1,14.885,14.3,1.386,1.386,0,0,1,13.5,15.68Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M13.5,9c-4.625,0-8.289,4.934-8.442,5.143a.248.248,0,0,0,0,.295c.153.21,3.817,5.143,8.442,5.143s8.289-4.933,8.442-5.143a.248.248,0,0,0,0-.295C21.789,13.938,18.125,9,13.5,9Zm0,10.081c-3.937,0-7.276-3.968-7.925-4.79C6.224,13.473,9.563,9.5,13.5,9.5s7.276,3.969,7.925,4.791C20.776,15.117,17.44,19.085,13.5,19.085Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M6.075,11.189c.033-.032,3.382-3.274,7.425-3.274s7.392,3.242,7.425,3.274a.25.25,0,1,0,.351-.356c-.142-.14-3.525-3.418-7.776-3.418s-7.634,3.278-7.776,3.418a.25.25,0,1,0,.351.356Z"
		/>
	</svg>
)
